import "./styles.css";
import { useState } from "react";
import Loading from "./Loading";

//#026DB0
const TtimeMin = 60;
const startTime = new Date();
export default function App() {
  const [currentTime, setTime] = useState(new Date());
  const perRemain = () => {
    const timeGone = (currentTime - startTime) / 600;
    return Math.round(((timeGone / TtimeMin) * 100) / 60);
  };
  setInterval(() => setTime(new Date()), 30000);
  return (
    <>
      <div className="center">
        <Loading />
        <div className="text line-1">Working on Updates {perRemain()}%</div>
        <div className="text line-2">
          don't turn off your PC this will take a while
        </div>
      </div>
      <div className="text restart-message">
        your PC will restart several times
      </div>
    </>
  );
}
